import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import Navbar from "../Navbar";
import Footer from "./Footer";
import bgVideo from "../video/background.mp4";
import SEO from "../components/SEO";

export default function DetailsRea() {
  const { id } = useParams();

  const realisations = useSelector(state => state.homeReducer.realisations);
  const realisation = realisations.find(r => r.id === parseInt(id));

  const [mainImage, setMainImage] = useState(realisation?.images?.[0]);

  if (!realisation) return <p style={{ textAlign: "center" }}>Chargement en cours...</p>;

  return (
    <div className="realisations-page">
      <SEO
        title={`${realisation.title || "Réalisation"} — SCI MAYEDO`}
        description={realisation.description || `Découvrez ce projet immobilier réalisé par SCI MAYEDO : ${realisation.title || "réalisation"} en Côte d'Ivoire.`}
        canonical={`/detail/realisation/${id}`}
        image={realisation.images?.[0] || null}
      />
      <Navbar />

      <div className="container breadcrumb-container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Accueil</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/Nos--realisations">Nos réalisations</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {realisation.name}
            </li>
          </ol>
        </nav>
      </div>

      <div className="project-header">
        <h2 className="title">{realisation.name}</h2>
        <p>{realisation.city} - {realisation.address}</p>
      </div>

      <div className="video-section">
        <video autoPlay loop muted playsInline>
          <source src={bgVideo} type="video/mp4" />
          Votre navigateur ne supporte pas la lecture vidéo.
        </video>
      </div>

      <section className="gallery-section">
        <div className="main-image">
          <img src={`${process.env.PUBLIC_URL}/${mainImage}`} alt="Réalisation" />
        </div>

        <div className="thumbnails">
          {realisation.images.map((img, idx) => (
            <img
              key={idx}
              src={`${process.env.PUBLIC_URL}/${img}`}
              alt={`thumb-${idx}`}
              className={mainImage === img ? "active" : ""}
              onClick={() => setMainImage(img)}
            />
          ))}
        </div>
      </section>

      <section className="description-section container">
        <h3>Description</h3>
        <ul>
          {realisation.description.map((item, idx) => (
            <li key={idx}>• {item}</li>
          ))}
        </ul>
        {realisation.prices && (
          <p className="price">À partir de <strong>{realisation.prices} FCFA</strong></p>
        )}
      </section>

      <Footer />
    </div>
  );
}